import { PositiveColors, Shadows } from '@picsart/design-system/foundation/colors';
import { TypographyT10, TypographyT9 } from '@picsart/design-system/foundation/typography';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import getBannerLinearGradinet from 'utils/colors/getBannerLinearGradient';

const useStyles = createUseStyles<string, { color: string; leftSideColor: string }>(
  {
    root: {
      background: ({ color }) => getBannerLinearGradinet(color),
      minHeight: 368,
      marginBottom: 74,
      width: '100%',

      '@media screen and (max-width: 1112px)': {
        minHeight: 664,
        marginBottom: 100,
      },

      '@media screen and (max-width: 768px)': {
        marginBottom: Spacings.s10,
      },

      '@media screen and (max-width: 275px)': {
        marginBottom: 200,
      },
    },

    horizontalContainer: {
      display: 'flex',
      gap: Spacings.s16,
      height: '100%',
      justifyContent: 'space-between',
      maxWidth: 1440,
      marginInline: 'auto',
      paddingInline: 60,

      '@media screen and (max-width: 1112px)': {
        flexDirection: 'column',
        paddingInline: Spacings.s16,
      },
    },

    breadcrumb: {
      marginBottom: Spacings.s40,
      textAlign: 'left',

      // breadcrumb has some default padding
      '&>div>div': {
        paddingLeft: 0,
      },
    },

    infoContainer: {
      alignSelf: 'flex-end',
      borderRadius: CornerRadius.r12,
      backgroundColor: PositiveColors.base.default,
      boxShadow: Shadows.tint1,
      display: 'flex',
      flexDirection: 'column',
      padding: 20,
      position: 'relative',
      top: Spacings.s64,
      width: 'min(560px, 100%)',

      '@media screen and (max-width: 1112px)': {
        alignSelf: 'center',
        top: Spacings.s16,
      },
    },

    textContainer: {
      marginInline: 'auto',
      maxWidth: 'min(100%, 648px)',

      '@media screen and (max-width: 1112px)': {
        textAlign: 'center',
      },
    },

    title: {
      marginBottom: Spacings.s16,
      '&&': {
        color: ({ leftSideColor }) => leftSideColor,
      },
    },

    titleSize: {
      ...TypographyT10,

      '@media screen and (max-width: 1112px)': {
        '&&': {
          ...TypographyT9,
        },
      },
    },

    description: {
      marginBottom: Spacings.s32,
      '&&': {
        color: ({ leftSideColor }) => leftSideColor,
      },
    },

    cta: {
      marginBlockEnd: Spacings.s24,

      '@media screen and (max-width: 1112px)': {
        marginBlockEnd: Spacings.s0,
      },
    },

    info: {
      backgroundColor: ({ color }) => color,
      height: 219,
      marginBottom: 20,
    },

    infoText: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '100%',
    },

    colorName: {
      marginBottom: Spacings.s10,
    },

    copyContainer: {
      display: 'flex',
      alignItems: 'center',
    },

    copyButton: {
      height: 40,
      marginLeft: Spacings.s8,
      maxWidth: 40,
      minWidth: 40,
    },
  },
  {
    name: 'color-banner',
  },
);

export default useStyles;
